import { UPDATE_TEAM, DESELECT_TEAM, SELECT_TEAM } from "../actions/team";

export const initialState = null;

const team = (state = initialState, { type, payload }) => {
  switch (type) {
    case DESELECT_TEAM.TYPE:
      return initialState;

    case SELECT_TEAM.TYPE:
      return payload;

    case UPDATE_TEAM.RESOLVED:
      return payload.id === state.id ? payload : state;

    default:
      return state;
  }
};

export default team;
